export const backgroundColor = '#2c3639';
export const elementsColor = '#3f4e4f';
export const textColor = '#fff';

export const darkThemeStyles = {
  header: {
    backgroundColor: backgroundColor,
    color: textColor,
    border: `1px solid ${elementsColor}`,
  },

  inputsElements: {
    background: elementsColor,
    color: textColor,
  },

  basic: {
    background: backgroundColor,
    color: textColor,
  },

  elements: {
    backgroundColor: elementsColor,
    color: textColor,
    boxShadow: 'none',
  },
  hover: { border: `1px solid red` },
  textColor,
  elementsColor,
  backgroundColor,
};
